const GLOBAL_ENV = {
    API_HOST: 'https://api.zilch.ninja',
    LEGACY_HOST: 'https://portal.zrs.nz',
    REPORT_HOST: 'https://data.zilch.nz/reports',
    STRIPE_API_KEY: process.env.VUE_APP_STRIPE_API_PROD_KEY,
    STRIPE_SECRET_KEY: process.env.VUE_APP_STRIPE_SECRET_PROD_KEY,
    GOOGLE_MAPS_API_KEY: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    ADDY_URL: 'https://api-nz.addysolutions.com/search/',
    ADDY_KEY: process.env.VUE_APP_ADDY_KEY,
    ADDY_SECRET: process.env.VUE_APP_ADDY_SECRET,
    ADD_SUPER_FLOW: true,
}

const ENV_SANDBOX = {
    ...GLOBAL_ENV,
    REPORT_HOST: 'https://carbndw-api.azurewebsites.net/api',
    API_HOST: 'https://api.zilch.services'
}

const ENV_DEV = {
    ...GLOBAL_ENV,
    API_HOST: 'https://api.zilch.services',
    REPORT_HOST: 'https://carbndw-api.azurewebsites.net/api',
    // STRIPE_API_KEY: process.env.VUE_APP_STRIPE_API_TEST_KEY,
    // STRIPE_SECRET_KEY: process.env.VUE_APP_STRIPE_SECRET_TEST_KEY,
}

const ENV_UAT = {
    ...GLOBAL_ENV,
    LEGACY_HOST: 'https://account.zilch.nz',
    REPORT_HOST: 'https://carbndw-api.azurewebsites.net/api',
    // ADDY_KEY: 'f5d76db6b99e4d13a3db499309d11a00',
}

const ENV_PROD = {
    ...ENV_UAT,
    ADD_SUPER_FLOW: false,
    API_HOST: 'https://api.zilch.services',
    REPORT_HOST: 'https://carbndw-api.azurewebsites.net/api',
}

let env = ENV_PROD;
if (process.env.NODE_ENV === 'development') {
    env = ENV_DEV;
} else if (process.env.NODE_ENV === 'sandbox') {
    env = ENV_SANDBOX;
} else if (process.env.NODE_ENV === 'staging') {
    env = ENV_UAT;
} else {
    env = ENV_PROD;
}
const environment = env;

export default environment;